/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricAccessListRequest extends models.BillingMetricAccessBase {
    getFixupPrototypeFunction() { return BillingMetricAccessListRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricAccessListRequest>): BillingMetricAccessListRequest {
        let obj = Object.assign(new BillingMetricAccessListRequest(), model);
        BillingMetricAccessListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricAccessListRequest>): BillingMetricAccessListRequest {
        if (!model) return null;
        return BillingMetricAccessListRequest.newInstance(<BillingMetricAccessListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricAccessListRequest) {
        if (!obj) return;

        models.BillingMetricAccessListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricAccessListRequest): boolean {
        if (models.BillingMetricAccessBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingMetricAccessListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.BillingMetricAccessFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Filters for the Billing Metrics
     */
    filters: models.BillingMetricAccessFilters;

}
